import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, submit } from './modules'
import Loading from 'components/Loading'
import { languageChange, checkIsLogin } from 'store/siteConfig'

export default function(route) {
  const Qrcode = Loadable({
    loader: () => import('./Qrcode'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          feedbackQrcodeState: state.feedbackQrcodeState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          submit,
          checkIsLogin
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/qrcode`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Qrcode {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
